// src/pages/AuthAction.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function AuthAction() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mode = params.get("mode");

    if (mode === "verifyEmail") {
      navigate(`/verify-email?${params.toString()}`, { replace: true });
    } else if (mode === "resetPassword") {
      navigate(`/reset-password?${params.toString()}`, { replace: true });
    } else if (mode === "recoverEmail" || mode === "verifyAndChangeEmail") {
      navigate(`/verify-email?${params.toString()}`, { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [location, navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px", fontSize: "18px" }}>
      正在跳转，请稍候...
    </div>
  );
}
